exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-switch.is-disabled[data-v-410294a0]{opacity:1}[data-v-410294a0] .el-switch__label{cursor:pointer !important}", ""]);

// exports
